import React from 'react';
import { Button, Typography, Paper } from '@material-ui/core';
import { Cancel as CancelIcon } from '@material-ui/icons';
import { AuthCookie, Environment } from '../../api';
import '../layout/style.css';

const Unauthorized = () => {
  const loginUrl = AuthCookie.getLoginUrl();
  return (
    <Paper align="center">
      <CancelIcon className="oopsIcon" />
      <Typography variant="display1" gutterBottom>
        Unauthorized
      </Typography>
      <Button color="primary" href={loginUrl || Environment.defaultLoginUrl}>
        Log in
      </Button>
    </Paper>
  );
};

export default Unauthorized;



// WEBPACK FOOTER //
// ./src/components/pages/Unauthorized.js